// 用户应用环境域名
export const userEnvMap: { [key: string]: string } = {
  dev: "sandbox",
  test: "sandbox",
  uat: "sandbox",
  prod: "production",
  pre: "pre",
}
